import React, { CSSProperties } from 'react'
import clsx from 'clsx'

import { BaseDivProps } from 'src/types'

type Props = {
  border?: number
  gradientOpacity?: number
  borderColor?: string
} & BaseDivProps

function GradientWrapper({ border = 1, borderColor = '#4E8FC6',className, children, gradientOpacity = 1 }: Props) {
  return (
    <div className={clsx('relative', className)}>
      {children}
      {border !== 0 && (
        <div
          className='rounded-lg pointer-events-none absolute inset-0 z-[1]'
          style={{ border: border === 0 ? undefined : `${border}px solid ${borderColor}`, opacity: gradientOpacity } as CSSProperties}
        />
      )}
    </div>
  )
}

export default GradientWrapper
